<script setup>
import {useRouter} from 'vue-router'
import GoogleSheetConnectionSvg from "@/components/UI/svg/GoogleSheetConnectionSvg.vue";
import IntegrationsSvg from "@/components/UI/svg/IntegrationsSvg.vue";
import GalleryTemplatesSvg from "@/components/UI/svg/GalleryTemplatesSvg.vue";
import {Api} from "@/service/api";

const router = useRouter();


async function createUserWorkflow() {
    let newWorkflowId = await Api.createEmptyWorkflow()
    router.push({"name": "CreateConnection", params:{workflow_id: newWorkflowId}})
}

</script>

<template>
    <div class="flex h-screen w-full overflow-y-hidden">
        <div class="flex flex-col w-full h-full overflow-y-auto">
            <!-- Hero секция -->
            <div class="flex flex-col items-center justify-center px-4 py-12 lg:p-20 gap-5 mb-14">
                <div class="font-bold text-lg md:text-xl lg:text-5xl text-center max-w-4xl">
                    Готовы начать?
                </div>
                <div class="text-center max-w-3xl font-bold text-base md:text-lg text-gray-500">
                    Автоматизируйте копирование ваших данных из различных источников в итоговые таблицы, используя визуальную настройку и фильтры
                </div>
            </div>

            <!-- Карточки -->
            <div class="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-8 xl:gap-12 px-4 pb-8 lg:px-8 lg:mx-12 xl:mx-20 2xl:mx-40">

                <!-- Карточка 1: Интеграции -->
                <div class="w-full max-w-md lg:w-1/3 h-auto min-h-[320px] lg:h-[400px] border border-blue-400 rounded-3xl flex flex-col">
                    <div class="w-full m-auto flex items-center justify-center py-6 lg:py-0 lg:h-40">
                        <IntegrationsSvg class="size-32" />
                    </div>
                    <div class="flex flex-col mt-auto mb-6 lg:mb-10 px-4 items-center gap-4">
                        <div class="text-sm lg:text-sm text-center px-2 font-bold text-gray-600">
                            Найдите связки, которые вам подходят и начните с шаблона
                        </div>
                        <div class="cursor-default select-none w-fit flex items-center justify-center bg-gray-600  font-bold text-white px-6 lg:px-8 py-2.5 lg:py-2 rounded-full text-xs lg:text-sm transition-colors">
                            Скоро
                        </div>
                    </div>
                </div>

                <!-- Карточка 2: Пустая область -->
                <div class="w-full max-w-md lg:w-1/3 h-auto min-h-[320px] lg:h-[400px] border border-blue-400 rounded-3xl flex flex-col hover:shadow-lg transition-shadow relative">
                    <div class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold bg-[#f3f7fc] px-4 text-blue-600 text-lg">
                        Рекомендуем
                    </div>
                    <div class="w-full max-w-md h-auto min-h-[320px] lg:h-[400px] rounded-3xl flex flex-col">
                        <div class="w-full m-auto flex items-center justify-center py-6 lg:py-0 lg:h-40">
                            <div class="w-32 h-32 lg:w-40 lg:h-40 bg-gray-100 rounded-2xl flex items-center justify-center">
                                <GoogleSheetConnectionSvg class="size-36" />
                            </div>
                        </div>
                        <div class="flex flex-col mt-auto mb-6 lg:mb-10 px-4 items-center gap-2">
                            <div class="text-sm lg:text-sm text-center px-2 font-bold text-gray-600">
                                Создайте пустую рабочую область и добваьте соединения
                            </div>
                            <button v-on:click="createUserWorkflow"
                                class="w-fit flex items-center justify-center bg-blue-500 hover:bg-blue-600 font-bold text-white px-6 lg:px-8 py-2.5 lg:py-2 rounded-full text-xs lg:text-sm transition-colors mt-2"
                            >
                                Создать
                            </button>
                        </div>
                    </div>

                </div>

                <!-- Карточка 3: Галерея -->
                <div class="w-full max-w-md lg:w-1/3 h-auto min-h-[320px] lg:h-[400px] border border-blue-400 rounded-3xl flex flex-col">
                    <div class="w-full m-auto flex items-center justify-center py-6 lg:py-0 lg:h-40">
                        <div class="w-32 h-32 lg:w-40 lg:h-40 bg-gray-100 rounded-2xl flex items-center justify-center">
                            <GalleryTemplatesSvg />
                        </div>
                    </div>
                    <div class="flex flex-col mt-auto mb-6 lg:mb-10 px-4 items-center gap-4">
                        <div class="text-sm lg:text-sm text-center px-2 font-bold text-gray-600">
                            Выберите готовые отраслевые шаблоны и настройте их под себя
                        </div>
                        <div class="cursor-default select-none w-fit flex items-center justify-center bg-gray-600  font-bold text-white px-6 lg:px-8 py-2.5 lg:py-2 rounded-full text-xs lg:text-sm transition-colors">
                            Скоро
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Дополнительные стили для плавности */
.transition-shadow {
    transition: box-shadow 0.2s ease-in-out;
}

/* Кастомный скроллбар (опционально) */
.overflow-y-auto::-webkit-scrollbar {
    width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
}
</style>